import { AppBreakpoint } from '@makyoapp/makyo-sdk/models/AppBuilder'
import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import {
  Desktop16,
  MobilelandscapePhone16,
  MobilePhone16,
  Tablet16,
  Tabletlandscape16,
  Tv16,
} from '@makyoapp/makyo-icon/icon'

export const COLUMN_SELECT_ROW_ID_KEY = '_id'
export const BADGE_METADATA_COL_TYPES = [
  ColumnTypes.Number,
  ColumnTypes.Text,
  ColumnTypes.Rating,
  ColumnTypes.DateTime,
  ColumnTypes.Function,
  ColumnTypes.Join,
  ColumnTypes.Email,
]

export const TEXT_ABLE_COLUMN_TYPES_NO_ICON = [
  ColumnTypes.Text,
  ColumnTypes.RichText,
  ColumnTypes.Email,
  ColumnTypes.URL,
  ColumnTypes.Phone,
  ColumnTypes.Number,
  ColumnTypes.Rating,
  ColumnTypes.DateTime,
  ColumnTypes.Slug,
  ColumnTypes.RowID,
  ColumnTypes.Address,
  ColumnTypes.AISEO,
  ColumnTypes.AITextProcessing,
  ColumnTypes.Attachment,
  ColumnTypes.Coordinate,
  ColumnTypes.Image,
  ColumnTypes.Lookup,
]
export const TEXT_ABLE_COLUMN_TYPES_TEXT_ONLY = [
  ColumnTypes.Text,
  ColumnTypes.RichText,
  ColumnTypes.Function,
  ColumnTypes.URL,
  ColumnTypes.Email,
  ColumnTypes.Address,
  ColumnTypes.Boolean,
  ColumnTypes.Coordinate,
  ColumnTypes.DateTime,
  ColumnTypes.Join,
  ColumnTypes.Color,
  ColumnTypes.Number,
  ColumnTypes.Math,
  ColumnTypes.Phone,
  ColumnTypes.Rating,
  ColumnTypes.RowID,
  ColumnTypes.Slug,
  ColumnTypes.Lookup,
]

export const BUILDER_DEVICES: Record<
  AppBreakpoint,
  {
    id: AppBreakpoint
    label: string
    Icon: (props: React.ComponentProps<'svg'>) => JSX.Element
  }
> = {
  phone: {
    id: 'phone',
    label: 'Mobile (Portrait)',
    Icon: MobilePhone16,
  },
  'phone-landscape': {
    id: 'phone-landscape',
    label: 'Mobile (Landscape)',
    Icon: MobilelandscapePhone16,
  },
  tablet: {
    id: 'tablet',
    label: 'Tablet (Portrait)',
    Icon: Tablet16,
  },
  'tablet-landscape': {
    id: 'tablet-landscape',
    label: 'Tablet (Landscape)',
    Icon: Tabletlandscape16,
  },
  desktop: {
    id: 'desktop',
    label: 'Desktop/Laptop',
    Icon: Desktop16,
  },
  tv: {
    id: 'tv',
    label: 'TV',
    Icon: Tv16,
  },
}
